import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Pagination as SemanticPagination } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
class Pagination extends Component {
    static propTypes = {
        elmId: PropTypes.string,
        footer: PropTypes.node,
        className: PropTypes.string,
    };
    render() {
        const { elmId = 'pagination', footer, className, ...rest } = this.props;
        return (_jsxs("div", { "data-elm-id": elmId, className: cx('pagination-container'), children: [_jsx(SemanticPagination, { ...rest, className: cx('pagination', className) }), footer] }));
    }
}
Pagination.propsTypes = SemanticPagination.propsTypes;
export default Pagination;
//# sourceMappingURL=index.js.map